import { FormLayout, PasswordInput, SubmitButton, TextInput } from '@expressable/syntax-ds';
import { useTranslation } from 'react-i18next';
import { useFormContext } from 'react-hook-form';

type Props = {
  isLoading: boolean;
  selfSignUp?: boolean;
  emailParam?: string;
  translationSuffix?: string;
};

export const FormUi = ({ isLoading, emailParam, translationSuffix }: Props): JSX.Element => {
  const { t } = useTranslation();
  const { register } = useFormContext();

  return (
    <>
      <FormLayout.Fields>
        <TextInput
          name="email"
          data-testid="form-confirmation-code"
          autoFocus
          label={t('login.form.fields.email')}
          value={emailParam as string}
          disabled
        />

        <PasswordInput
          {...register('password')}
          data-testid="form-force-new-password-new-password"
          hint={t('login.newPassword.passwordRequirements')}
          label={t('login.form.fields.newPassword')}
        />

        <PasswordInput
          {...register('passwordConfirm')}
          data-testid="form-force-new-password-confirm-new-password"
          label={t('login.form.fields.confirmPassword')}
        />
      </FormLayout.Fields>

      <FormLayout.GlobalErrors message={t('intake.form.validationErrors')} />

      <FormLayout.CTA>
        <SubmitButton data-testid="form-force-new-password-button" size="lg" fullWidth disabled={isLoading}>
          {t(`login.passwordReset.submit${translationSuffix}`)}
        </SubmitButton>
      </FormLayout.CTA>
    </>
  );
};
